import {
  Component,
  EventEmitter,
  OnInit,
  Output,

} from '@angular/core';
import {Notification} from '../../data/Notification';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {NotificationService} from '../../services/notification/notification.service';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: '1',
      })),
      state('closed', style({
        opacity: '0',
        'pointer-events': 'none'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class NotificationListComponent implements OnInit {
  @Output() notificationSelection: EventEmitter<Notification> = new EventEmitter<Notification>();
  @Output() closeNotificationPopup: EventEmitter<boolean> = new EventEmitter<boolean>();

  get areNotificationsEmpty(): boolean {
    if (!this.notificationService.notifications) {
      return true;
    }
    return this.notificationService.notifications.length === 0;
  }

  constructor(public notificationService: NotificationService ) {
  }

  ngOnInit(): void {
  }

  dismissNotification(index: number): void {
    this.notificationService.notifications.splice(index, 1);
  }

  closePopUp(): void {
    this.closeNotificationPopup.emit(true);
  }

  dismissAllNotifications(): void {
    setTimeout(() => {
      this.notificationService.notifications = [];
    }, 500);

    // if (this.notifications){
    //   let i = this.notifications.length;
    //   const maxLength = this.notifications.length;
    //   while (i >= 0){
    //     // this.childrenNotifications.filter((elem, index) => index === i)[0].nativeElement.applyDisappearAnimation();
    //     setTimeout(() => {
    //       this.notifications.splice(i - 1, 1);
    //     }, 200 * (maxLength - i));
    //     i--;
    //   }
    // }
  }


}
